<template>
  <div class="ExerciseAnswer">
    <div class="answer">
      <div class="item_info">
        <!-- 提问者信息 -->
        <div class="answer_item">
          <img class="avatar"
               :src="tea_answer.avatar" />
          <div class="title">
            <span class="name">{{tea_answer.nickname}}</span>
            <span class="desc">{{tea_answer.created_at}}</span>
          </div>
          <div class="top_right_icon">
            <span class="icon_span number"
                  @click="clickLike(tea_answer, 1)"
                  :class="tea_answer.is_like==1?'is_like':''"> <i></i> {{tea_answer.like_number}}</span>
          </div>
        </div>
        <div class="free">
          <!-- 提问内容 -->
          <div class="one-level-answer">
            <span class="ask_icon">问</span> 
            <span v-html="tea_answer.content"></span>
          </div>
          <!-- 回答者信息 -->
          <div v-if="tea_answer.a_id">
            <div class="answer_item">
              <div class="info">
                <img class="avatar"
                   :src="tea_answer.a_avatar" />
                <div class="title">
                  <span class="name">{{tea_answer.a_real_name}}</span>
                  <span class="desc">{{tea_answer.a_created_at}}</span>
                </div>
                <div class="top_right_icon">
                  <span class="icon_span number"
                        @click="clickLike(tea_answer, 2)"
                        :class="tea_answer.a_is_like==1?'is_like':''"> <i></i> {{tea_answer.a_like_number}}</span>
                </div>
              </div>
              <div class="free">
                <div class="one-level-answer">
                  <span class="an_icon">答</span> 
                  <span v-html="tea_answer.a_content"></span>
                </div>
              </div>
            </div>
            <div class="answer_img"
                 v-if="tea_answer.a_images">
              <preview :imgList="tea_answer.a_images?tea_answer.a_images.split(','):[]"></preview>
            </div>
            <div class="ask_btn"
                 type="info"
                 @click="ask_more(tea_answer)">追问</div>
            <div class="pursue_answer" v-show="tea_answer.child.data.length">
              <!-- <div class="noAnswer"
                   v-if="tea_answer.child.data.length==0">
                暂无数据
              </div> -->
              <div class="baseInfo"
                   v-for="(child,index) in tea_answer.child.data"
                   :key="index">
                <div class="info">
                  <img class="avatar"
                     :src="child.avatar" />
                  <div class="title">
                    <span class="name">{{child.user_name}}</span>
                    <span class="desc">{{child.created_at}}</span>
                  </div>
                  <div class="top_right_icon">
                    <span class="icon_span number"
                          :class="child.is_like==1?'is_like':''"
                          @click="clickLike(child)"><i></i>{{child.like_number}} </span>
                  </div>
                </div>
                <div class="one-level-answer">
                  <span v-if="child.ait">回复<span class="ait">@{{child.ait}}</span></span>
                  <span v-html="child.content"></span>
                </div>
              </div>
              <div class="more"
                   v-if="tea_answer.child.data.length>4"
                   @click="lookMore(tea_answer)">{{more}}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import preview from '@/components/que_answers/Preview'
export default {
  components: {
    preview
  },
  data () {
    return {
      more: '查看更多'
    };
  },
  props: {
    tea_answer: {
      type: Object,
      default () {
        return {};
      }
    },
    load_more_url: {
      type: String,
      default () {
        return '/api/app/ask/zaskChildList';
      }
    }
  },
  created () {
    // console.log(this.tea_answer)
  },
  methods: {
    clickLike (item,flag) {
      let params = { ask_id: item.ask_id || item.id, comment_id:flag?(flag == 2?item.a_id:0):item.id, user_type: 1 };
      this.$pub.clickLike(params).then((res) => {
        if(flag == 2) {//点赞讲师回答
          if (item.a_is_like == 0) {
            item.a_is_like = 1;
            item.a_like_number++;
          } else {
            item.a_is_like = 0;
            item.a_like_number--;
          }
        } else {
          if (item.is_like == 0) {
            item.is_like = 1;
            item.like_number++;
          } else {
            item.is_like = 0;
            item.like_number--;
          }
        }
      });
    },
    onPay (item) {
      this.$pub.toPay({
        order_price: item.order_price,
        order_number: item.order_number,
        order_id: item.id,
        type: item.shop_type,
        shop_id: item.shop_ids
      });
    },
    ask_more (item) {
      this.$emit('ask_more', item)
    },
    lookMore (answer) {
      if (this.more === '查看更多') {
        let page = answer.child.current_page;
        page = page + 1;
        if (page <= answer.child.last_page) {
          this.$http.get(this.load_more_url, { id: answer.a_id, page: page }).then(res => {
            if (res.list.length > 0) {
              answer.child.data = answer.child.data.concat(res.list);
              answer.child.current_page = res.current_page;
              if (res.list.length < 5) {
                this.more = '已加载全部';
              }
            } else {
              this.more = '已加载全部';
            }
          });
        } else {
          this.more = '已加载全部';
        }
      }
    },
    showPreviewImg (item) {
      this.$set(item, 'showPreview', true)
    },
    // setImgArr (item) {
    //   let arrImg = [];
    //   let arr = item.images.split(',');
    //   return arrImg;
    // }
  }
};
</script>

<style lang="scss" scoped>
.ExerciseAnswer {
  // @extend %default-bg;
  font-family: PingFang SC;
  background-color: #f6f6f6;
  .answer {
    // margin-top: 30px;
    background: #fff;
    // height: 700px;
    .answer_title {
      line-height: 80px;
      font-size: 24px;
      color: #333333;
      height: 80px;
      border-bottom: 1px solid #f6f6f6;
      padding-left: 29px;
    }
    .item_info {
      padding: 0 30px;
      .free > .one-level-answer{
        padding-top: 20px;
      }
      .answer_item,.info {
        overflow: hidden;
      }
      .charge {
        display: block;
        overflow: hidden;
        border-bottom: 1px solid #f6f6f6;
        margin-bottom: 30px;
        .pay_btn {
          width: 480px;
          height: 88px;
          line-height: 88px;
          color: #fff;
          font-size: 34px;
          background-color: $theme_color;
          text-align: center;
          margin: 0 auto;
          margin-top: 74px;
          border-radius: 10px;
        }
        .person_num {
          color: #333333;
          font-size: 24px;
          text-align: center;
          margin-top: 21px;
          margin-bottom: 58px;
        }
      }
      .title {
        float: left;
        display: flex;
        flex-direction: column;
      }
      .avatar {
        display: block;
        margin-right: 16px;
        margin-top: 10px;
        float: left;
        width: 50px;
        height: 50px;
        border-radius: 50%;
      }
      .name {
        @include eps;
        font-size: 28px;
        font-weight: 500;
        color: #333;
        padding: 5px 0;
      }
      .desc {
        @include eps;
        font-size: 22px;
        color: #999;
        margin-top: 5px;
      }
      .one-level-answer {
        // float: left;
        // overflow: hidden;
        line-height: 33px;
        font-size: 24px;
        color: #666666;
        padding: 0 30px 20px 60px;
      }
      .more {
        text-align: center;
        height: 46px;
        line-height: 46px;
        font-size: 24px;
        color: #666666;
      }
      .ask_btn {
        text-align: center;
        background: $theme_color;
        color: #fff;
        width: 81px;
        height: 40px;
        line-height: 40px;
        margin-left: 64px;
        font-size: 22px;
        border-radius: 4px;
      }
      .answer_img {
        padding: 20px 64px;
      }
    }
  }
  .pursue_answer {
    padding: 34px 10px 0 29px;
    margin: 20px 0 0 64px;
    background-color: #f6f6f6;
    .one-level-answer {
      // padding-top: 80px !important;
      margin-top: 20px;
      margin-bottom: 30px;
    }
    &:last-child {
      margin-bottom: 0;
    }
    .noAnswer {
      text-align: center;
      padding-bottom: 34px;
      font-size: 30px;
    }
  }
  .top_right_icon {
    float: right;
    // margin-top: -20px;
    display: flex;
    align-items: center;
    .icon_span {
      font-size: 22px;
      color: #999;
      line-height: 26px;
      margin: 0 10px;
      display: inline-block;
    }
    .collect {
      padding: 0 0 0 34px;
      background: url("~@/assets/images/collect@2x.png") left center no-repeat;
      background-size: 26px 25px;
    }
    .number {
      i {
        display: inline-block;
        width: 28px;
        height: 21px;
        background: url("~@/assets/images/zan@2x.png") left center no-repeat;
        background-size: 21px 21px;
      }
    }
  }
  .ask_icon{
    margin-right: 8px;
  }
  .ask_icon,
  .an_icon {
    display: inline-block;
    width: 28px;
    height: 28px;
    background-color: $theme_color;
    color: #fff;
    line-height: 28px;
    text-align: center;
    border-radius: 4px;
    font-size: 20px;
  }
  .an_icon {
    background-color: #f0b501;
  }
}
</style>
